import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors, typography, spacing } from '../../theme';
import { designTokens } from '../../theme/design-system';
import { withAlpha } from '../../theme';

export interface ChannelStatusIndicatorProps {
  status: 'pending' | 'synced' | 'error' | 'never_synced' | 'syncing';
  size?: 'small' | 'medium' | 'large';
}

export const ChannelStatusIndicator: React.FC<ChannelStatusIndicatorProps> = ({
  status,
  size = 'medium',
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'synced':
        return {
          icon: 'checkmark-circle',
          color: colors.success || '#10B981',
          label: 'Synced',
          bgColor: (colors.success || '#10B981') + '20',
        };
      case 'syncing':
        return {
          icon: 'sync',
          color: colors.primary,
          label: 'Syncing',
          bgColor: withAlpha(colors.primary, 0.13),
        };
      case 'error':
        return {
          icon: 'alert-circle',
          color: colors.error,
          label: 'Error',
          bgColor: withAlpha(colors.error, 0.13),
        };
      case 'pending':
        return {
          icon: 'time-outline',
          color: colors.warning || '#F59E0B',
          label: 'Pending',
          bgColor: (colors.warning || '#F59E0B') + '20',
        };
      case 'never_synced':
      default:
        return {
          icon: 'ellipse-outline',
          color: colors.textLight,
          label: 'Not Synced',
          bgColor: colors.lightGray,
        };
    }
  };

  const config = getStatusConfig();
  const iconSize = size === 'small' ? 14 : size === 'large' ? 20 : 16;
  const fontSize = size === 'small' ? typography.fontSize.xs : size === 'large' ? typography.fontSize.sm : typography.fontSize.xs;

  return (
    <View style={[styles.container, { backgroundColor: config.bgColor }]}>
      <Ionicons name={config.icon as any} size={iconSize} color={config.color} />
      <Text style={[styles.label, { color: config.color, fontSize }]}>{config.label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs / 2,
    paddingHorizontal: spacing.xs,
    paddingVertical: 2,
    borderRadius: designTokens.borderRadius.sm,
  },
  label: {
    fontFamily: typography.fontFamily.medium,
    fontWeight: '500',
  },
});

